<template>
  <div class="h-auto">
    <div v-if="!showTeamMember">
      <div class="bg-white m-3 rounded-md">
        <div class="border-b-0.5 flex justify-between items-center py-3">
          <p class="text-sm font-semibold">Pending Claim Requests</p>
        </div>
        <!-- {{ approvedClaims }} -->
        <el-tabs type="border-card">
          <transition name="fade">
            <div
              v-if="isApproved"
              class="text-center text-sm w-full bg-green-200"
            >
              {{ approveMessage }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="decline_success"
              class="text-center text-sm w-full bg-green-200"
            >
              {{ decline_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="decline_error"
              class="text-center text-sm w-full bg-yellow-200"
            >
              {{ decline_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <div class="">
            <div class="" v-if="pendingClaims.length">
              <div class="flex justify-between items-center p-2">
                <!-- search -->
                <input
                  v-model="searchInput"
                  type="search"
                  placeholder="Start typing to search..."
                  class="bg-gray-200 w-52 py-1 rounded-md"
                />
                <!-- search -->
              </div>

              <div>
                <ve-table
                  :columns="columns"
                  :table-data="filteredTableData"
                  sort-order="asc"
                />

                <p
                  v-if="searchInput.length && filteredTableData.length === 0"
                  class="text-center py-3"
                >
                  No results
                </p>
              </div>
            </div>
            <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
              No Claims found
            </p>
          </div>
        </el-tabs>
      </div>

      <div class="bg-white m-3 rounded-md">
        <div class="border-b-0.5 flex justify-between items-center py-3">
          <p class="text-sm font-semibold">Claim History</p>
        </div>

        <el-tabs type="border-card" @tab-click="(e) => setTab(e)">
          <el-tab-pane
            v-for="(tab, index) in tabs"
            :key="index"
            :label="tab.name"
          >
            <div class="" v-if="filteredClaimHistoriesTableData.length">
              <div class="border-b-0.5 flex justify-between items-center p-2">
                <!-- search -->
                <input
                  v-model="searchInput2"
                  type="search"
                  placeholder="Start typing to search..."
                  class="bg-gray-200 w-52 py-1 rounded-md"
                />
                <!-- search -->
              </div>

              <div>
                <ve-table
                  :columns="columns"
                  :table-data="filteredClaimHistoriesTableData"
                  sort-order="asc"
                />

                <p
                  v-if="
                    searchInput2.length &&
                    filteredClaimHistoriesTableData.length === 0
                  "
                  class="text-center py-3"
                >
                  No results
                </p>
              </div>
            </div>
            <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
              No Claims found
            </p>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div v-if="showTeamMember">
      <team-member @backToTeam="showTeamMember = false"></team-member>
    </div>
    <claim-decline-reason
      :showAddReason="showAddReason"
      :setReason="setReason"
      @close="handleClose"
    >
    </claim-decline-reason>

    <approval-warning
      :show-approval-warning="showApprovalWarning"
      :setIsConfirmed="setIsConfirmed"
      @close="showApprovalWarning = false"
    >
    </approval-warning>

    <review-claim
      :showReviewClaim="showReviewClaim"
      :closeReview="close"
      :approvalEntries="approvalEntries"
      :claimDetails="claimDetails"
      :attachmentUrl="attachmentUrl"
    ></review-claim>
  </div>
</template>

<script>
import axios from "axios";
import TeamMember from "./teamMember.vue";
import ClaimDeclineReason from "./addReason.vue";
import ApprovalWarning from "./approvalWarning.vue";

import ReviewClaim from "./reviewClaim.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import decryptData from "@/utils/decrypt";
import { formatCurrency } from "@/utils/currencyFomatter";
export default {
  name: "TeamClaim",

  components: {
    TeamMember,
    ClaimDeclineReason,
    ReviewClaim,
    ApprovalWarning,
  },
  data() {
    return {
      RowId: null,
      showClaimApplicationModal: false,
      pendingClaims: [],
      approvedClaims: [],
      declinedClaims: [],
      approval: [],
      claimApplication: {
        pdfUrl: "https://www.africau.edu/images/default/sample.pdf",
        docUrl: "https://example.com/myfile.docx",
        images: [
          "https://example.com/image1.jpg",
          "https://example.com/image2.jpg",
        ],
      },
      showAttachments: false,
      attachmentUrl: null,
      showRequestClaim: false,
      reason: null,
      message: null,
      create_error: null,
      create_success: null,
      showTeamMember: false,
      isApproved: false,
      isDeclined: false,
      isConfirmed: false,
      approveMessage: null,
      decline_error: null,
      decline_success: null,
      showAddReason: false,
      approvalEntries: null,
      claimDetails: null,
      showReviewClaim: false,
      showApprovalWarning: false,
      rowToApprove: null,
      searchInput: "",
      searchInput2: "",
      selectedTab: 0,
      teamKey: 0,
      mineKey: 1,
      get_error: null,
      tabs: [
        {
          name: "Approved",
          route: "mine",
        },
        {
          name: "Declined",
          route: "team",
        },
      ],

      currentTab: 0,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "Name",
          title: "Name",
          align: "left",
          width: "15%",
          renderBodyCell: ({ row }) => {
            return (
              <div class="flex gap-5 items-center">
                <p
                  class="text-blue-500 cursor-pointer"
                  on-click={() => {
                    this.attachmentUrl = row.Attachment;
                    this.approvalEntries = row.ApprovalEntries;
                    this.claimDetails = row;
                    this.showReviewClaim = true;
                    this.showAttachments = true;
                  }}
                >
                  {decryptData(row.Name, this.$decryptionKey)}
                </p>
              </div>
            );
          },
        },
        {
          field: "ClaimType",
          key: "ClaimType",
          title: "Type",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "DateApplied",
          key: "DateApplied",
          title: "Applied Date",
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ row }) => (
            <p class="text-left">{this.formatDate(row.DateApplied)}</p>
          ),
        },

        {
          field: "Amount",
          key: "amount",
          title: "Amount",
          renderBodyCell: ({ row }) => formatCurrency(row.Amount),
        },

        {
          field: "Description",
          key: "description",
          title: "Description",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "Action",
          key: "ff",
          title: "Action",
          align: "center",
          headerAlign: "center",
          renderBodyCell: ({ row }) => {
            return (
              <ve-popper
                trigger="clickToOpen"
                options={{
                  placement: "top",
                  modifiers: { offset: { offset: "0,10px" } },
                }}
              >
                <div class="bg-white p-2 shadow-md popper">
                  <button
                    class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                    style="boder-radius: 0 !important"
                    on-click={() => {
                      this.rowToApprove = row;

                      this.showApprovalWarning = true;
                    }}
                  >
                    Approve
                  </button>
                  <button
                    class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                    style="boder-radius: 0 !important"
                    on-click={() => this.declineClaim(row)}
                  >
                    Decline
                  </button>
                </div>

                <button slot="reference">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Outline"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                  >
                    <circle cx="12" cy="2" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="22" r="2" />
                  </svg>
                </button>
              </ve-popper>
            );
          },
        },
      ],

      columns2: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "aa",
          title: "Name",
          align: "left",
          width: "15%",
          renderBodyCell: ({ row }) => {
            return (
              <div
                onClick={() => {
                  this.attachmentUrl = row.Attachment;
                  this.approvalEntries = row.ApprovalEntries;
                  this.claimDetails = row;
                  this.showReviewClaim = true;
                  this.showAttachments = true;
                  //console.log(row)
                }}
                class="flex gap-5 items-center"
              >
                <div class="h-8 w-8 rounded-full">
                  <img
                    class="h-full w-full rounded-full"
                    src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
                  />
                </div>
                <p class="text-blue-500 cursor-pointer">{row.Name}</p>
              </div>
            );
          },
        },
        {
          field: "ClaimType",
          key: "ClaimType",
          title: "Type",
          align: "left",
          headerAlign: "left",
        },
        {
          field: "DateApplied",
          key: "DateApplied",
          title: "Date Applied",
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ row }) => {
            return <p class="text-left"> {this.formatDate(row.DateApplied)}</p>;
          },
        },

        {
          field: "Amount",
          key: "Amount",
          title: "Amount",
          renderBodyCell: ({ row }) => formatCurrency(row.Amount),
        },

        {
          field: "Description",
          key: "description",
          title: "Description",
          align: "left",
          headerAlign: "left",
        },
      ],

      tableData: [],
      tableData2: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.pendingClaims;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.pendingClaims.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    filteredClaimHistoriesTableData() {
      let data =
        this.currentTab == 0 ? this.approvedClaims : this.declinedClaims;

      if (!this.searchInput2) {
        // If no search input is provided, return the full tableData
        return data;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput2.toLowerCase();
        return this.data.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
  },
  created() {
    this.getTeamClaims(this.currentTab);
    this.updateClaimList(this.selectedTab);
  },
  methods: {
    close() {
      this.showReviewClaim = false;
    },
    setTab(event) {
      const { id } = event["$el"];

      switch (id) {
        case "pane-0":
          this.selectedTab = 0;
          this.updateClaimList(0);
          break;
        case "pane-1":
          this.selectedTab = 1;
          this.updateClaimList(1);
          break;
      }
    },
    setIsConfirmed() {
      this.isConfirmed = true;
      this.approveClaim(this.rowToApprove);
    },
    showClaimApplication() {
      if (this.showClaimApplicationModal) {
        this.showClaimApplicationModal = false;
      } else {
        this.showClaimApplicationModal = true;
      }
    },
    closeClaimApplicationModal() {
      this.showClaimApplicationModal = false;
    },

    viewTeamMember() {
      this.showTeamMember = true;
    },
    formatDate(dateStr) {
      return moment(dateStr).format("DD/MM/YYYY");
    },
    setReason(reason) {
      const data = {
        Id: this.RowId,
        Reason: reason,
        Status: "Declined",
      };
      this.submit(data);
    },
    getTeamClaims() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      axios
        .get(
          `${this.getOrganization}/employee/claim/myteam/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status == 200) {
              this.$emit("closeOnSuccess");

              this.tableData = this.filterTeamClaims(response.data.Data, "All");

              this.pendingClaims = this.filterTeamClaims(
                this.tableData,
                "Pending"
              );
              this.approvedClaims = this.filterTeamClaims(
                this.tableData,
                "Approved"
              );
              console.log(this.approvedClaims);
              this.declinedClaims = this.filterTeamClaims(
                this.tableData,
                "Declined"
              );
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    filterTeamClaims(data, status) {
      if (status === "Pending") {
        return data
          .filter((claim) => claim.Status === "Pending")
          .sort((a, b) => new Date(b.DateApplied) - new Date(a.DateApplied));
      } else if (status === "Declined") {
        return data.filter((entry) => entry.Status === "Declined");
      } else if (status === "Approved") {
        console.log(
          status,
          data.filter((entry) => entry.Status === "Approved")
        );
        return data.filter((entry) => entry.Status === "Approved");
      } else if (status === "All") {
        return data.sort(
          (a, b) => new Date(b.DateApplied) - new Date(a.DateApplied)
        );
      }
      // console.log(status, data)
      // return data;
    },
    // /{organization}/employee/claim/v1/process
    approveClaim({ Id, Reason }) {
      const data = {
        Id,
        ClaimId: Id,
        Reason: Reason,
        Status: "Approved",
      };
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.showApprovalWarning = false;

      axios
        .post(
          `${this.getOrganization}/employee/claim/${this.$ApiVersion}/process`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;

            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
              this.getTeamClaims(this.currentTab);
              this.tableData = response.data.Data;
              // this.create_success = response.data.StatusMessage;
              this.$notify({
                title: "Success",
                message: "Claim approved successfully!",
                type: "success",
              });
              setTimeout(() => {
                this.isApproved = true;
                this.create_success = null;
              }, 3000);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 3000);
          }
        );
    },

    declineClaim({ Id }) {
      this.showAddReason = true;
      this.loading = true;
      this.RowId = Id;
    },

    submit(data) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      // alert(this.getOrganization);
      if (data.Reason) {
        this.loading = true;
        this.showAddReason = false;
        axios
          .post(
            `${this.getOrganization}/timeoff/${this.$ApiVersion}/process`,
            JSON.stringify(data),
            options
          )
          .then(
            (response) => {
              //console.log(response.data);
              this.loading = false;
              if (response.status == 200) {
                this.$emit("closeOnSuccess");
                this.getTeamClaims(this.currentTab);
                this.tableData = response.data.Data;
                this.decline_success = response.data.StatusMessage;
                setTimeout(() => {
                  this.isDeclined = true;
                  this.decline_success = null;
                }, 3000);
              } else {
                this.decline_error = response.data.StatusMessage;
                setTimeout(() => {
                  this.isDeclined = true;
                  this.decline_error = null;
                }, 3000);
              }
            },
            (error) => {
              this.loading = false;
              this.decline_error = error.message;
            }
          );
      } else {
        this.decline_error = "Reason for declination missing";
      }
    },

    handleClose() {
      this.showAddReason = false;
      this.showApprovalWarning = false;
    },

    updateClaimList(currentTab) {
      this.currentTab = currentTab;
    },
  },
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
</style>
